  <!-- desktop/tablet view – unchanged -->
  <mat-card class="contact-banner desktop-view">
    <div class="contact-info">
      <div class="contact-item" *ngFor="let item of contactItems">
        <mat-icon>{{ item.icon }}</mat-icon>
        <a *ngIf="item.link" [href]="item.link">{{ item.display }}</a>
        <span *ngIf="!item.link">{{ item.display }}</span>
      </div>
    </div>
  </mat-card>

  <mat-card class="contact-banner mobile-view">
  <!-- handset view: wrap accordion in the same card for colours/etc -->
    <mat-accordion class="contact-accordion">
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            Contact Us
          </mat-panel-title>
        </mat-expansion-panel-header>

          <div class="contact-info">
            <div class="contact-item" *ngFor="let item of contactItems">
              <mat-icon>{{ item.icon }}</mat-icon>
              <a *ngIf="item.link" [href]="item.link">{{ item.display }}</a>
              <span *ngIf="!item.link">{{ item.display }}</span>
            </div>
          </div>
      </mat-expansion-panel>
    </mat-accordion>
  </mat-card>
